import { cn } from "libs/utils";
import { LoaderCircle } from "lucide-react";
import { ComponentPropsWithoutRef } from "react";

function LoadingIndicator(
  props: ComponentPropsWithoutRef<typeof LoaderCircle>
) {
  // return <span {...props} className={cn("loader", props.className)}></span>;
  return <LoaderCircle className={cn("animate-spin", props.className)} />;
}

export { LoadingIndicator };
export default LoadingIndicator;
